<div class="container-fluid">
  <div class="col-lg-5 col-md-5 mx-auto mt-5 text-center">
    <h4>Congratulations! You'have successfully changed your password.</h4>
    <p class="mt-3">
      <a [routerLink]="['/signin']" title="Login">Click here to Sign In</a>
    </p>
  </div>
</div>
